import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs';
import Vision from '../pages/Vision';
import ContactUs from '../pages/ContactUs';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/contact-us" element={<ContactUs />} />
    </Routes>
  );
}
